import { createRoot } from "react-dom/client";
import App from "./app/App.tsx";
import { LocaleProvider } from "./app/i18n/index.tsx";
import { ErrorBoundary } from "./components/common";
import "./styles/index.css";

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js", { scope: "/" })
      .catch((err) => console.error("SW registration failed:", err));
  });
}

// biome-ignore lint/style/noNonNullAssertion: standard React entry point pattern
createRoot(document.getElementById("root")!).render(
  <ErrorBoundary>
    <LocaleProvider>
      <App />
    </LocaleProvider>
  </ErrorBoundary>,
);
